export const decodeSensorHeatmapRaster = async (rasterBase64, signal) => {
  const match = /^data:image\/tiff;base64,([\s\S]+)$/.exec(rasterBase64 || "");
  if (!match) throw new Error("Formato del raster heatmap non valido");
  const binary = window.atob(match[1]);
  const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
  const { fromArrayBuffer } = await import("geotiff");
  const tiff = await fromArrayBuffer(bytes.buffer, signal);
  try {
    const image = await tiff.getImage();
    const width = image.getWidth();
    const height = image.getHeight();
    const boundingBox = image.getBoundingBox();
    const transform = image.getFileDirectory().getValue("ModelTransformation");
    const [resolutionX, resolutionY] = image.getResolution();
    if (
      image.getGeoKeys()?.ProjectedCSTypeGeoKey !== 3857 ||
      image.getSamplesPerPixel() !== 4 ||
      [0, 1, 2, 3].some((band) => image.getBitsPerSample(band) !== 8) ||
      !Number.isInteger(width) ||
      width <= 0 ||
      !Number.isInteger(height) ||
      height <= 0 ||
      boundingBox.length !== 4 ||
      !boundingBox.every(Number.isFinite) ||
      boundingBox[0] >= boundingBox[2] ||
      boundingBox[1] >= boundingBox[3] ||
      (transform &&
        (transform[1] !== 0 ||
          transform[4] !== 0 ||
          transform[0] <= 0 ||
          transform[5] >= 0)) ||
      (!transform && !(resolutionX > 0 && resolutionY < 0))
    ) {
      throw new Error(
        "Georeferenziazione o bande del raster heatmap non valide",
      );
    }
    const pixels = await image.readRasters({ interleave: true, signal });
    if (pixels.length !== width * height * 4)
      throw new Error("Raster heatmap incompleto");
    // The API already applies the colour scale and field mask, including alpha.
    return {
      width,
      height,
      boundingBox,
      pixels: new Uint8ClampedArray(pixels),
    };
  } finally {
    await tiff.close();
  }
};
